import PropTypes from 'prop-types'

import FormLayout from '../../../ui/views/shippingSend/FormLayout'

const propTypes = {
  children: PropTypes.node,
}

const Step1Origin = ({ children }) => {
  return <FormLayout>{children}</FormLayout>
}

Step1Origin.propTypes = propTypes

export default Step1Origin
